const styles = () => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    '@media (max-width: 959px)': {
      width: '100%',
    },
  },
  description: {
    marginBottom: '10px',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '24px',
  },
  title: {
    alignSelf: 'flex-start',
  },
  buttonRow: {
    alignSelf: 'flex-start',
  },
  logo: {
    width: '48px',
    height: '48px',
    alignSelf: 'flex-end',
  },
  button: {
    width: '127px',
    height: '40px',
    fontSize: '14px',
  },
  buttonIcon: {
    color: 'white',
  },
});

export default styles;
